var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollbar",style:(`position:relative;overflow-y:${
    _vm.noScrolling ? 'hidden' : 'auto'
  };background-color:${_vm.backgroundColor};width:${_vm.width};height:${_vm.height}`)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }